import { Component, Input } from '@angular/core';
import { DuplicateResolutions } from '../../model/duplicate-resolutions';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MergeChildrenModalComponent } from './merge-children-modal/merge-children-modal.component';

@Component({
    selector: 'merge-children-btn',
    templateUrl: './merge-children-btn.component.html',
    styleUrls: ['./merge-children-btn.component.scss']
})
export class MergeChildrenBtnComponent {
    @Input() duplicateResolution!: DuplicateResolutions;

    constructor(private dialog: MatDialog) {}

    ngOnInit(): void {}

    // Dialog Modal
    openDialog() {
        let payload: any = {};
        payload.duplicateResolution = this.duplicateResolution;

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.data = payload;
        dialogConfig.maxHeight = '99vh';
        dialogConfig.minWidth = '90vw';
        const dialogRef = this.dialog.open(MergeChildrenModalComponent, dialogConfig);

        dialogRef.afterClosed().subscribe((res: any) => {
            if (res) {
                console.log(res);
            }
        });
    }
}
